import { useState, type FormEvent } from "react";
import type { TravelerId } from "../types";
import { voterFromPassphrase } from "../lib/voterSession";

interface Props {
  onUnlock: (voterId: TravelerId) => void;
}

export function PasswordGate({ onUnlock }: Props) {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  const submit = (event: FormEvent) => {
    event.preventDefault();
    const voterId = voterFromPassphrase(value);
    if (!voterId) {
      setError("That passphrase isn’t right.");
      return;
    }
    setError("");
    onUnlock(voterId);
  };

  return (
    <div className="gate-screen">
      <form className="gate-card" onSubmit={submit}>
        <p className="eyebrow">CHILE · 2026</p>
        <h1>The long way.</h1>
        <p className="gate-copy">Enter the trip passphrase to open the itinerary.</p>
        <label htmlFor="trip-passphrase">
          Passphrase
          <input
            id="trip-passphrase"
            type="password"
            name="passphrase"
            autoComplete="current-password"
            autoFocus
            value={value}
            aria-invalid={error ? true : undefined}
            aria-describedby={error ? "gate-error" : undefined}
            onChange={(e) => {
              setValue(e.target.value);
              if (error) setError("");
            }}
          />
        </label>
        {error && (
          <p id="gate-error" className="gate-error" role="alert">
            {error}
          </p>
        )}
        <button type="submit" className="btn">
          Open trip
        </button>
      </form>
    </div>
  );
}
